import { parseAbi } from "viem";

/** Minimal ERC-721 surface for approvals + stake path. */
export const erc721Abi = parseAbi([
  "function approve(address to, uint256 tokenId) external",
  "function setApprovalForAll(address operator, bool approved) external",
  "function getApproved(uint256 tokenId) view returns (address)",
  "function isApprovedForAll(address owner, address operator) view returns (bool)",
]);

/** Reads only — for `multicall` (no events). */
export const stakingReadAbi = parseAbi([
  "function stakeInfo(uint256 tokenId) view returns (address owner, uint64 stakedAt)",
]);

export const stakingAbi = parseAbi([
  "function stake(uint256 tokenId) external",
  "function stakeBatch(uint256[] tokenIds) external",
  "function unstake(uint256 tokenId) external",
  "function unstakeBatch(uint256[] tokenIds) external",
  "function paused() view returns (bool)",
  "function stakeInfo(uint256 tokenId) view returns (address owner, uint64 stakedAt)",
  "function canStake(address user) view returns (bool)",
  "function cooldownEndsAt(address user) view returns (uint256)",
  "function OWLEX_NFT() view returns (address)",
  "function XP() view returns (address)",
  "event Staked(address indexed user, uint256 indexed tokenId, uint64 stakedAt)",
  "event Unstaked(address indexed user, uint256 indexed tokenId, uint256 xpMinted)",
  "event EmergencyReturn(address indexed staker, uint256 indexed tokenId)",
]);

export const erc20Abi = parseAbi([
  "function balanceOf(address account) view returns (uint256)",
  "function decimals() view returns (uint8)",
  "function allowance(address owner, address spender) view returns (uint256)",
  "function approve(address spender, uint256 amount) external returns (bool)",
]);

/** OwlexTraitSpin — reads + writes */
export const traitSpinReadAbi = parseAbi([
  "function xpForRequestSpin(uint256 traitTypeId) view returns (uint256)",
]);

export const traitSpinAbi = parseAbi([
  "function requestSpin(uint256 traitTypeId, uint256 layerIndex) payable",
  "function requestSpinBatch(uint256[] traitTypeIds, uint256[] layerIndices) payable",
  "function requestSpinWithCredit(uint256 traitTypeId, uint256 layerIndex)",
  "function requestSpinBatchWithCredit(uint256[] traitTypeIds, uint256[] layerIndices)",
  "function quoteBatchCreditSpin(uint256[] traitTypeIds, uint256[] layerIndices) view returns (uint256 outfitCreditsNeeded, uint256 nonOutfitCreditsNeeded)",
  "function quoteBatchSpin(uint256[] traitTypeIds, uint256[] layerIndices) view returns (uint256 totalXp, uint256 totalEth)",
  "function revealSpin()",
  "function paused() view returns (bool)",
  "function spinLayerCount(uint256 traitTypeId) view returns (uint256)",
  "function traitPoolLength(uint256 traitTypeId, uint256 layerIndex) view returns (uint256)",
  "function ethForRequestSpin(uint256 traitTypeId) view returns (uint256)",
  "function xpForRequestSpin(uint256 traitTypeId) view returns (uint256)",
  "function pendingQueueLen(address user) view returns (uint256)",
  "function pendingQueueItem(address user, uint256 index) view returns (uint256, uint256, uint256, uint256)",
  "function buyNonOutfitSpinCreditsBatch(uint256 count) payable",
  "function buyOutfitSpinCreditsBatch(uint256 count) payable",
  "function quoteNonOutfitCreditsEth(uint256 count) pure returns (uint256 totalEth)",
  "function quoteOutfitCreditsEth(uint256 count) view returns (uint256 totalEth)",
  "function outfitTraitTypeId() view returns (uint256)",
  "function traitTypeCount() view returns (uint256)",
  "function traitTypeName(uint256 traitTypeId) view returns (string)",
  "function traitAt(uint256 traitTypeId, uint256 layerIndex, uint256 poolIndex) view returns (string)",
  "function spinLayerName(uint256 traitTypeId, uint256 layerIndex) view returns (string)",
  "function layerCloudflareId(uint256 traitTypeId, uint256 layerIndex) view returns (string)",
  "function unboundTraitCount(address user) view returns (uint256)",
  "function unboundTraitAt(address user, uint256 index) view returns (bytes32)",
  "function spinCredits(address) view returns (uint256)",
  "function outfitSpinCredits(address) view returns (uint256)",
  "function equipTrait(uint256 tokenId, uint256 traitTypeId, uint256 layerIndex, string traitName) external",
  "function unequipTrait(uint256 tokenId, uint256 traitTypeId) external",
  "function equippedTrait(uint256 tokenId, uint256 traitTypeId) view returns (bytes32)",
  "function ownsTrait(address user, bytes32 traitId) view returns (bool)",
]);

/** OwlexTraitMarketplace — list / buy */
export const traitMarketplaceAbi = parseAbi([
  "function listTrait(bytes32 traitId, uint256 price, bool payInEth) external returns (uint256 listingId)",
  "function cancelListing(uint256 listingId) external",
  "function buyWithEth(uint256 listingId) external payable",
  "function buyWithXp(uint256 listingId) external",
  "function activeListingId(address seller, bytes32 traitId) external view returns (uint256)",
  "function paused() view returns (bool)",
  "function nextListingId() view returns (uint256)",
  "function listings(uint256 listingId) view returns (address seller, bytes32 traitId, uint256 price, bool payInEth, bool active)",
]);
